export default __webpack_public_path__ + "static/media/dial-tone.9d8008cd.mp3";